import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { IntegrationUtilService } from "../../integration/services/integration-util.service";
import { PaymentsRepositoryService } from "../../payments/services/payments-repository.service";
import { DwLoginInfo, DwLoginRegistrationInfoProvider, DwRegisterationInfo } from "@devwareapps/devware-cap";
import { map } from "rxjs/operators";
import { StripeSessionDetailsResult } from "../../payments/models/stripe-session-details-result.model";
import { AviatorRegistrationDraftService } from "./aviator-registration-draft.service";


@Injectable()
export class DwLoginRegistrationInfoProviderService implements DwLoginRegistrationInfoProvider {

    constructor(private integrationUtilService: IntegrationUtilService,
        private paymentsRepositoryService: PaymentsRepositoryService,
        private aviatorRegistrationDraftService: AviatorRegistrationDraftService

    ) {
    }

    getLoginInfo(): Observable<DwLoginInfo> {
        return this.getStripeDetails()
            .pipe(map(stripeDetails => {
                const draft = this.aviatorRegistrationDraftService.loadDraft();

                if (stripeDetails) {
                    return {
                        userName: stripeDetails.CustomerEmail,
                    } as DwLoginInfo;
                }

                if (draft?.account?.userName) {
                    return {
                        userName: draft.account.userName,
                    } as DwLoginInfo;
                }

                return null;
        }));

    }
    getRegistrationInfo(): Observable<DwRegisterationInfo> {
          return this.getStripeDetails()
            .pipe(map(stripeDetails => {
                const draft = this.aviatorRegistrationDraftService.loadDraft();

                if (stripeDetails) {
                    return {
                        userName: stripeDetails.CustomerEmail,
                        email: stripeDetails.CustomerEmail,
                        firstName: stripeDetails.CustomerFirstName,
                        lastName: stripeDetails.CustomerLastName,
                    } as DwRegisterationInfo;
                }

                if (draft?.account) {
                    return {
                        userName: draft.account.userName,
                        email: draft.account.email,
                        firstName: draft.account.firstName,
                        lastName: draft.account.lastName,
                        lockEmail: draft.account.lockEmail,
                    } as DwRegisterationInfo;
                }

                return null;
        }));
    }

    private getStripeDetails(): Observable<StripeSessionDetailsResult> {
        const stripeToken = this.integrationUtilService.getStripeToken();
        if (stripeToken) {
            return this.paymentsRepositoryService.getStripeSessionDetails(stripeToken);
        } else {
            return of(null);
        }
    }
}
